<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>K.S. King is an award-winning Canadian journalist, reporting and editing publications on crime and courts, education, politics, oil and gas, agriculture, indigenous relations and the environment. Growing up in a rural Newfoundland out-port community, Savage Cove, (pop. 133), King was surrounded by storytellers, fishermen, hunters, tanners, gardeners, and crafters. She is married to an Anglican pastor; has two LGBTQ2S+ sons and routinely volunteers in the LGBTQ2S+ community, Anglican ministries, and facilitating Christian women’s retreats.</p><br/>
<p style="text-indent: 0em;">Today, King shares her journalism and communication knowledge, as well as her love of reading, to students and staff as middle-school librarian in Calgary.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?746e3bdc